import { EventEmitter, Injectable, Output } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CommunicationService {
  @Output() message$: EventEmitter<any> = new EventEmitter();

  sendMessage(message: any) {
    this.message$.emit(message);
  }
}
